export enum StepInvoiceControls {
  InvoiceNumber = 'CustomerNumber',
  InvoiceDate = 'InvoiceDate',
  InvoiceType = 'InvoiceType',
  InvoiceCheckbox = 'InvoiceCheckbox',
}
